import type { OptionsArrayKeys } from '@halo/utils';
import { OptionsArray } from '@halo/utils';
import languageMap from './locales';
import 'dayjs/locale/en';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/zh-tw';
import 'dayjs/locale/vi';
import 'dayjs/locale/ar';
import 'dayjs/locale/be';
import 'dayjs/locale/ca';
import 'dayjs/locale/cs';

// Map
export { languageMap };

// import './helper';

// List
export const languageList = new OptionsArray([
  {
    key: 'en',
    label: 'English',
    dayjsKey: 'en',
  },
  {
    key: 'ar',
    label: 'العربية',
    dayjsKey: 'ar',
  },
  {
    key: 'be',
    label: 'Беларуская',
    dayjsKey: 'be',
  },
  {
    key: 'ca',
    label: 'Hrvatski',
    dayjsKey: 'ca',
  },
  {
    key: 'cs',
    label: 'Čeština',
    dayjsKey: 'cs',
  },
  // {
  //   key: 'zh-CN',
  //   label: '简体中文',
  //   dayjsKey: 'zh-cn',
  // },
  {
    key: 'zh-TW',
    label: '繁体中文',
    dayjsKey: 'zh-tw',
  },
  {
    key: 'vi',
    label: 'Tiếng Việt',
    dayjsKey: 'vi',
  },
] as const);

export const defaultLanguage = 'en';

export type LanguageListKeys = OptionsArrayKeys<typeof languageList>;

export type LanguageList = typeof languageList;

export type LanguageItem = LanguageList[number];

languageList.forEach((item) => {
  if (!(item.value in languageMap)) {
    console.error(
      `The configuration item whose key is '${item.key}' is missing from the language list.`
    );
  }
});
